// extracted by mini-css-extract-plugin
var _1 = "no-wrap__V3eCg";
export { _1 as "noWrap" }
